<template>
  <div class="index_m">
    <div class="headers">
      <p class="logo-img">
        <img src="./../assets/img/logo3.png" />
      </p>
      <img
        @click="visible = !visible"
        src="./../assets/img/menu.png"
        alt=""
        class="menu"
      />
    </div>
    <router-view />
    <div class="footers">
      <div class="footers-content">
        <div class="top">
          <p>{{ currentLg.address }}</p>
        </div>
        <div class="top" style="margin-top:12px;">
          <p>
            {{ currentLg.Copyright }}
            <span @click="goGxb('https://beian.miit.gov.cn')">{{
              currentLg.gov
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <popup :visible.sync="visible">
      <div class="pop-box">
        <img
          @click="close"
          class="delete"
          src="./../assets/img/delete.png"
          alt=""
        />
        <div class="menu-list">
          <p
            v-for="(item, index) in menuList"
            :key="index"
            @click="goPath(item.path)"
            :class="index !== menuList.length - 1 ? 'line' : ''"
          >
            {{ item[`name_${locale}`] }}
          </p>
        </div>
        <div class="locale" @click="showLocale">
          <img class="lg" src="./../assets/img/lg-m.png" alt="" />
          <span>{{ $i18n.locale == "CN" ? "中文" : "EN" }}</span>
          <img class="down" src="./../assets/img/down-m.png" alt="" />
        </div>
      </div>
    </popup>

    <!-- 中英文 -->
    <popup :visible.sync="visibleLocale">
      <div class="pop-box">
        <div class="menu-list locale-list">
          <div class="back-icon" @click="back">
            <img class="back" src="./../assets/img/back.png" alt="" />
            <span>{{ currentLg.back }}</span>
          </div>
          <p class="tip">{{ currentLg.language }}</p>
          <p
            v-for="(item, index) in localList"
            :key="index"
            class="line"
            @click="changeLanguage(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </popup>

    <!-- 回到顶部 -->
    <img
      v-show="$route.name !== 'product_m' && show"
      @click="toTop"
      class="back-top"
      src="./../assets/img/up.png"
      alt=""
    />
  </div>
</template>

<script>
import popup from "./../component/Popup.vue";
import language from "./../language/header/index";
export default {
  data() {
    return {
      visible: false,
      visibleLocale: false,
      menuList: [
        { name_CN: "首页", name_EN: "Home page", path: "/home_m" },
        { name_CN: "产品服务", name_EN: "Project Cases", path: "/product_m" },
        { name_CN: "项目案例", name_EN: "Product Services", path: "/case_m" },
        { name_CN: "关于我们", name_EN: "About", path: "/about_m" },
      ],
      localList: [
        { name: "中文", id: "CN" },
        { name: "EN", id: "EN" },
      ],
      show: false,
    };
  },
  components: {
    popup,
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  mounted() {
    // 禁用双指放大
    document.documentElement.addEventListener("touchstart", this.handleTouch, {
      passive: false,
    });

    // 禁用双击放大
    // let lastTouchEnd = 0;
    // document.documentElement.addEventListener(
    //   "touchend",
    //   function(event) {
    //     let now = Date.now();
    //     if (now - lastTouchEnd <= 300) {
    //       event.preventDefault();
    //     }
    //     lastTouchEnd = now;
    //   },
    //   { passive: false }
    // );
    document.documentElement.addEventListener("touchend", this.handleClick, {
      passive: false,
    });
    document.documentElement.addEventListener(
      "scroll",
      this.handleScroll,
      true
    );
  },
  methods: {
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      const windowHeight = e.target.clientHeight;
      const scrollHeight = e.target.scrollHeight;
      if (scrollTop + windowHeight == scrollHeight) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    changeLanguage(type) {
      this.$i18n.locale = type;
      this.visibleLocale = false;
      this.visible = false;
      localStorage.setItem("languageSet", this.$i18n.locale); //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    goPath(path, type) {
      this.type = type;
      this.visible = false;
      this.$router.push({ path: "/index_m" + path });
    },
    // 禁止手指缩放
    handleTouch(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    handleClick() {
      let lastTouchEnd = 0;
      let now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    goGxb(url) {
      window.open(url, "_blank");
    },
    showLocale() {
      this.visible = false;
      this.visibleLocale = true;
    },
    close() {
      this.visible = false;
      this.visibleLocale = false;
    },
    toTop() {
      document.querySelector("#app").scrollTo({ top: 0, behavior: "smooth" });
    },
    back() {
      this.visibleLocale = false;
      this.visible = true;
    },
  },
  beforeDestroy() {
    document.documentElement.removeEventListener(
      "touchstart",
      this.handleTouch,
      {
        passive: false,
      }
    );
    document.documentElement.removeEventListener("touchend", this.handleClick, {
      passive: false,
    });
  },
};
</script>
<style lang="less" scoped>
.index_m {
  .back-top {
    width: 12vw;
    position: absolute;
    bottom: 35vh;
    right: 6vw;
    z-index: 10;
  }
  .logo-img {
    width: 100vw;
    height: 6vh;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 4vh;
    }
  }
  .headers {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 10;
    height: 6vh;
    display: flex;
    background: rgba(0, 0, 0, 0.22);
  }
  .menu {
    position: absolute;
    height: 100%;
  }
  .pop-box {
    border-radius: 0 0 1vh 1vh;
    background-color: #fff;
    position: relative;
    .menu-list {
      padding: 3vh 4vw 0;

      p {
        line-height: 6vh;
      }
      .tip {
        font-size: 4vw;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 10vw;
      }
    }
    .delete {
      width: 4vw;
      position: absolute;
      top: 4vw;
      right: 4vw;
    }
  }
  .back-icon {
    display: flex;
    align-items: center;
  }
  .back {
    width: 4vw;
    margin-right: 2vw;
  }
  .locale {
    height: 6vh;
    background: #ebebeb;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 0 2vh 2vh;

    span {
      padding: 0 1vw;
    }
  }
  .lg {
    width: 4vw;
    margin-right: 2vw;
  }
  .down {
    width: 4vw;
    margin-left: 2vw;
  }
  .footers {
    background: rgba(46, 48, 51, 1);
    box-sizing: border-box;
    padding: 4vh 0;
    position: relative;
    .footers-content {
      .top {
        p {
          font-size: 4vw;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(199, 199, 199, 1);
          text-align: center;

          span {
            font-size: 4vw;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(199, 199, 199, 1);
            cursor: pointer;
          }
        }
      }
    }
  }
  .content-part {
    flex: 1;
  }
}
::-webkit-scrollbar {
  display: none;
}
.line {
  border-bottom: 1px solid #ebebeb;
}

.el-dropdown-menu {
  top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index_m.vue